import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { CalAngularService } from "@cvx/cal-angular";
import { catchError, switchMap } from "rxjs/operators";

import { environment } from "../../environments/environment";


export const authInterceptor: HttpInterceptorFn = (req, next) => {
  
  // first version work
  // Get token from storage or service
  //const token = localStorage.getItem("auth_token");

  //if (token) {
  //  const clonedRequest = req.clone({
  //    setHeaders: {
  //      Authorization: `Bearer ${token}`,
  //    },
  //  });
  //  return next(clonedRequest);
  //}
  //
  //return next(req);

  const calAngularService = inject(CalAngularService);
  
  // Define your scopes
  //const scopes = [".default"];
  const scopes = [`${environment.calClientId}/user_impersonation`];

  return calAngularService.isUserSignedIn().pipe(
    switchMap((isUserSignedIn) => {
      if (!isUserSignedIn) {
        return next(req);
      }

      return calAngularService.getAADToken(scopes).pipe(
        switchMap((tokenResult) => {
          const token =
            typeof tokenResult === "string"
              ? tokenResult
              : (tokenResult?.accessToken || tokenResult?.idToken || "");

          if (!token) {
            return next(req);
          }

          const clonedRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
          return next(clonedRequest);
        }),
        catchError((err) => {
          console.error("Error getting token in interceptor", err);
          return next(req);
        }),
      );
    }),
    catchError((err) => {
      console.error("Error checking auth state in interceptor", err);
      return next(req);
    }),
  );
};
